import React from 'react';

import { TriangleDownIcon } from '@modernloop/shared/icons';
import { ButtonProps, SxProps } from '@mui/material';

/**
 * @deprecated
 * These are helper props for select-style buttons.
 * When we move towards the new FilterSelect component or MUI Select, this should be removed.
 */
export const selectButtonProps_DO_NOT_USE: ButtonProps = {
  fullWidth: true,
  size: 'medium',
  endIcon: <TriangleDownIcon />,
  sx: {
    maxWidth: '100%',
    borderRadius: '6px',
    justifyContent: 'flex-start',
    '& .MuiButton-endIcon': { position: 'absolute', right: 12 },
  },
};
/**
 * @deprecated
 * These are helper props for the Stack inside select-style buttons.
 * When we move towards the new FilterSelect component or MUI Select, this should be removed.
 */
export const selectButtonLabelSxProps_DO_NOT_USE: SxProps = {
  maxWidth: '100%',
  paddingRight: 1.5,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};
